// Global Instructions Rule Applied!

import {
  SetInteractionsAction,
  UpdateInteractionAction,
  AddInteractionAction,
  RemoveInteractionAction,
  ClearInteractionsAction
} from '../../interfaces/interactions.ts'
import { InteractionRecord } from '../../data_models/interaction_record.ts'
import {
  SET_INTERACTIONS,
  UPDATE_INTERACTION,
  ADD_INTERACTION,
  REMOVE_INTERACTION,
  CLEAR_INTERACTIONS
} from './constants.ts'

export const setInteractions = (entityId: string, interactions: InteractionRecord[]): SetInteractionsAction => ({
  type: SET_INTERACTIONS,
  payload: { entityId, interactions }
})

export const updateInteraction = (
  entityId: string,
  interactionId: string,
  updates: Partial<InteractionRecord>
): UpdateInteractionAction => ({
  type: UPDATE_INTERACTION,
  payload: { entityId, interactionId, updates }
})

export const addInteraction = (entityId: string, interaction: InteractionRecord): AddInteractionAction => ({
  type: ADD_INTERACTION,
  payload: { entityId, interaction }
})

export const removeInteraction = (entityId: string, interactionId: string): RemoveInteractionAction => ({
  type: REMOVE_INTERACTION,
  payload: { entityId, interactionId }
})

const clearInteractions = (entityId: string): ClearInteractionsAction => ({
  type: CLEAR_INTERACTIONS,
  payload: { entityId }
})
